<template>
    <div class="flex flex-col gap-1">
        <targeting-router-link
            v-for="report in getNavigationEntriesByGroup(NavGroup.REPORTS)"
            :key="report.key"
            :to="report.target"
            :data-cy="`menu-entry-report-${report.key}`"
            class="nav-link"
            @click="closeMenu"
        >
            <div>
                {{ report.title }}
            </div>
        </targeting-router-link>
    </div>
</template>

<script setup lang="ts">

import { TargetingRouterLink } from '@tritt/multipanel'
import {getNavigationEntriesByGroup, NavGroup} from '@/navigation'

const props = defineProps<{ close?: () => void }>()

const closeMenu = () => {
    props.close?.()
}

</script>

<style scoped>
@reference "@/index.css";
@reference "tailwindcss";

.nav-link {
    @apply flex items-center hover:text-primary;
    i {
        @apply mr-1;
    }
}

</style>